import { useQuery } from '@tanstack/react-query';
import { AdminNpsSurveyService } from '../services/admin/admin-nps-survey.service';

export const CURRENT_NPS_SURVEY_QUERY_KEY = ['admin-current-nps-survey'];

export function useAdminCurrentNpsSurvey() {
  return useQuery({
    queryKey: CURRENT_NPS_SURVEY_QUERY_KEY,
    queryFn: () => AdminNpsSurveyService.getCurrentNpsSurvey(),
  });
}
